import { render } from "./About.vue?vue&type=template&id=d6bd69f2"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=d6bd69f2&lang=css"

import exportComponent from "/Users/admin/Downloads/project_output 2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__